import {Component, input, output} from '@angular/core';
import {ProjectDetailResponse, ProjectUserDetailResponse} from '@frontend/shared-api';
import {ProjectCardComponent} from './components/project-card.component';
import {CardListComponent} from '../../../../../shared/components/card/card-list/card-list.component';

@Component({
  selector: 'app-project-list',
  templateUrl: './project-list.component.html',
  imports: [ProjectCardComponent, CardListComponent],
})
export class ProjectListComponent {
  readonly projects = input<ProjectDetailResponse[]>([]);
  readonly projectUserDetails = input<Map<number, ProjectUserDetailResponse>>(new Map());
  readonly goToProjectEvent = output<number>();
  readonly editProjectEvent = output<number>();
  readonly archiveProjectEvent = output<number>();
  readonly deleteProjectEvent = output<number>();
  readonly copyProjectEvent = output<number>();
  readonly invitationResponseEvent = output<{
    projectId: number;
    accept: boolean;
  }>();

  trackByProjectId(index: number, project: ProjectDetailResponse): number {
    return project.id;
  }

  goToProject(id: number) {
    this.goToProjectEvent.emit(id);
  }

  onEdit(id: number) {
    this.editProjectEvent.emit(id);
  }

  onArchive(id: number) {
    this.archiveProjectEvent.emit(id);
  }

  onDelete(id: number) {
    this.deleteProjectEvent.emit(id);
  }

  onCopy(id: number) {
    this.copyProjectEvent.emit(id);
  }

  onInvitationResponse(projectId: number, accept: boolean) {
    this.invitationResponseEvent.emit({projectId, accept});
  }
}
